import { render, staticRenderFns } from "./InboxMessageNew.vue?vue&type=template&id=77da3ab6&scoped=true"
import script from "./InboxMessageNew.vue?vue&type=script&lang=ts"
export * from "./InboxMessageNew.vue?vue&type=script&lang=ts"
import style0 from "./InboxMessageNew.vue?vue&type=style&index=0&id=77da3ab6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77da3ab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77da3ab6')) {
      api.createRecord('77da3ab6', component.options)
    } else {
      api.reload('77da3ab6', component.options)
    }
    module.hot.accept("./InboxMessageNew.vue?vue&type=template&id=77da3ab6&scoped=true", function () {
      api.rerender('77da3ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxMessageNew.vue"
export default component.exports